var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import ReactDOM from 'react-dom';
import { GuardMode, GuardEventsCamelToKebabMapping, ReactAuthingGuard } from './types';
import { AuthenticationClient } from 'authing-js-sdk';
import { ajax } from './ajax';
import { GuardModuleType } from '@authing/react-ui-components';
export * from './types';
export { AuthenticationClient };
var Guard = /** @class */ (function () {
    function Guard(options) {
        var _this = this;
        this.visible = false;
        this.eventListeners = Object.values(GuardEventsCamelToKebabMapping).reduce(function (acc, evtName) {
            var _a;
            return Object.assign({}, acc, (_a = {},
                _a[evtName] = [],
                _a));
        }, {});
        this.options = Object.assign({}, {
            host: '',
            mode: 'normal',
            tanentId: '',
            align: 'none',
            config: __assign(__assign({}, options.config), { 
                // 向后兼容
                isSSO: options.isSSO || false, defaultScenes: options.defaultScene || 'login', lang: options.lang || 'zh-CN', host: options.host || '', mode: options.mode || 'normal' })
        }, options);
        var init = (function () { return __awaiter(_this, void 0, void 0, function () {
            var publicConfigRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.publicConfig) {
                            return [2 /*return*/, this.publicConfig];
                        }
                        return [4 /*yield*/, this.getPublicConfig()];
                    case 1:
                        publicConfigRes = _a.sent();
                        return [2 /*return*/, (this.publicConfig = publicConfigRes.data)];
                }
            });
        }); })();
        this.then = init.then.bind(init);
        this.visible = !!!(options.mode === GuardMode.Modal);
    }
    Guard.prototype.getPublicConfig = function () {
        var host = "".concat(this.options.host) || 'https://core.authing.cn';
        var _options = {
            method: 'GET',
            url: "".concat(host, "/api/v2/applications/").concat(this.options.appId, "/public-config")
        };
        return ajax(_options);
    };
    Guard.prototype.getAuthClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var publicConfig, _authClientOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.then()];
                    case 1:
                        publicConfig = _a.sent();
                        _authClientOptions = Object.assign({}, this.options.authClientOptions || {}, {
                            appId: this.options.appId,
                            appHost: this.options.host || "https://".concat(publicConfig.requestHostname),
                            redirectUri: this.options.redirectUri || publicConfig.oidcConfig.redirect_uris[0],
                            tokenEndPointAuthMethod: publicConfig.oidcConfig.token_endpoint_auth_method || 'none',
                            introspectionEndPointAuthMethod: publicConfig.oidcConfig.introspection_endpoint_auth_method || 'none'
                        });
                        return [2 /*return*/, new AuthenticationClient(_authClientOptions)];
                }
            });
        });
    };
    Guard.getGuardContainer = function (selector) {
        var defaultId = 'authing_guard_container';
        if (!selector) {
            var container = document.querySelector("#".concat(defaultId));
            if (!container) {
                container = document.createElement('div');
                container.id = defaultId;
                document.body.appendChild(container);
            }
            return container;
        }
        if (typeof selector === 'string') {
            return document.querySelector(selector);
        }
        return selector;
    };
    /**
     * 启动嵌入模式
     * @param el String
     * @returns Promise
     */
    Guard.prototype.start = function (el) {
        return __awaiter(this, void 0, void 0, function () {
            var userInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ;
                        this.options.config.target = el;
                        this.render();
                        return [4 /*yield*/, this.trackSession()];
                    case 1:
                        userInfo = _a.sent();
                        if (userInfo) {
                            return [2 /*return*/, Promise.resolve(userInfo)];
                        }
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.on('login', function (userInfo) {
                                    resolve(userInfo);
                                });
                            })];
                }
            });
        });
    };
    Guard.prototype.startRegister = function () {
        this.options.defaultScene = GuardModuleType.REGISTER;
        this.options.config = Object.assign({}, this.options.config, {
            defaultScenes: GuardModuleType.REGISTER
        });
        this.unmount();
        this.render();
    };
    Guard.prototype.checkLoginStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authClient, user, token, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthClient()];
                    case 1:
                        authClient = _a.sent();
                        return [4 /*yield*/, authClient.getCurrentUser()];
                    case 2:
                        user = _a.sent();
                        if (!user) {
                            return [2 /*return*/];
                        }
                        token = user.token;
                        if (!token) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, authClient.checkLoginStatus(token)];
                    case 3:
                        status = (_a.sent()).status;
                        if (status) {
                            return [2 /*return*/, user];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Guard.prototype.changeLang = function (lang) {
        this.options.lang = lang;
        this.options.config = Object.assign({}, this.options.config, {
            lang: lang
        });
        this.unmount();
        this.render();
    };
    Guard.prototype.changeContentCSS = function (contentCSS) {
        this.options.config = Object.assign({}, this.options.config, {
            contentCss: contentCSS
        });
        this.unmount();
        this.render();
    };
    /**
     * 启动跳转模式
     * @param {String} codeChallengeDigestMethod 'S256' | 'plain'
     * @param {String} codeChallengeMethod 'S256' | 'plain'
     */
    Guard.prototype.startWithRedirect = function (codeChallengeDigestMethod, codeChallengeMethod) {
        if (codeChallengeDigestMethod === void 0) { codeChallengeDigestMethod = 'S256'; }
        if (codeChallengeMethod === void 0) { codeChallengeMethod = 'S256'; }
        return __awaiter(this, void 0, void 0, function () {
            var authClient, codeChallenge, codeChallengeDigest, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthClient()
                        // 生成一个 code_verifier
                    ];
                    case 1:
                        authClient = _a.sent();
                        codeChallenge = authClient.generateCodeChallenge();
                        localStorage.setItem('codeChallenge', codeChallenge);
                        codeChallengeDigest = authClient.getCodeChallengeDigest({
                            codeChallenge: codeChallenge,
                            method: codeChallengeDigestMethod
                        });
                        url = authClient.buildAuthorizeUrl({
                            codeChallenge: codeChallengeDigest,
                            codeChallengeMethod: codeChallengeMethod
                        });
                        window.location.href = url;
                        return [2 /*return*/];
                }
            });
        });
    };
    Guard.prototype.handleRedirectCallback = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, code, codeChallenge, _b, id_token, access_token, authClient, userInfo;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.getCodeAndCodeChallenge(), code = _a.code, codeChallenge = _a.codeChallenge;
                        return [4 /*yield*/, this.getAccessTokenByCode(code, codeChallenge)];
                    case 1:
                        _b = _c.sent(), id_token = _b.id_token, access_token = _b.access_token;
                        return [4 /*yield*/, this.getAuthClient()];
                    case 2:
                        authClient = _c.sent();
                        return [4 /*yield*/, authClient.getUserInfoByAccessToken(access_token)];
                    case 3:
                        userInfo = _c.sent();
                        this.setStorageCache(access_token, id_token, userInfo);
                        return [2 /*return*/];
                }
            });
        });
    };
    Guard.prototype.getAccessTokenByCode = function (code, codeChallenge) {
        return __awaiter(this, void 0, void 0, function () {
            var authClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthClient()];
                    case 1:
                        authClient = _a.sent();
                        return [4 /*yield*/, authClient.getAccessTokenByCode(code, {
                                codeVerifier: codeChallenge
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Guard.prototype.getCodeAndCodeChallenge = function () {
        var query = this.parseUrlQuery();
        var _a = query.code, code = _a === void 0 ? '' : _a;
        var codeChallenge = localStorage.getItem('codeChallenge') || '';
        return {
            code: code,
            codeChallenge: codeChallenge
        };
    };
    Guard.prototype.setStorageCache = function (accessToken, idToken, userInfo) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('idToken', idToken);
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
    };
    Guard.prototype.parseUrlQuery = function () {
        var query = {};
        var queryString = window.location.search.split('?')[1];
        if (!queryString) {
            return query;
        }
        queryString.split('&').forEach(function (item) {
            var _a = __read(item.split('='), 2), key = _a[0], value = _a[1];
            query[key] = value;
        });
        return query;
    };
    /**
     * 获取当前用户信息
     */
    Guard.prototype.trackSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthClient()];
                    case 1:
                        authClient = _a.sent();
                        return [2 /*return*/, authClient.getCurrentUser()];
                }
            });
        });
    };
    Guard.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var redirectUri, idToken, logoutUrl, authClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        redirectUri = window.location.origin;
                        idToken = localStorage.getItem('idToken');
                        logoutUrl = '';
                        return [4 /*yield*/, this.getAuthClient()];
                    case 1:
                        authClient = _a.sent();
                        if (idToken) {
                            logoutUrl = authClient.buildLogoutUrl({
                                expert: true,
                                redirectUri: redirectUri,
                                idToken: idToken
                            });
                        }
                        localStorage.clear();
                        window.location.href = logoutUrl || redirectUri;
                        return [2 /*return*/];
                }
            });
        });
    };
    Guard.prototype.updateIdToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthClient()];
                    case 1:
                        authClient = _a.sent();
                        return [2 /*return*/, authClient.refreshToken()];
                }
            });
        });
    };
    Guard.prototype.render = function (cb) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var evts, publicConfig, authClient;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        evts = Object.entries(GuardEventsCamelToKebabMapping).reduce(function (acc, _a) {
                            var _b;
                            var _c = __read(_a, 2), reactEvt = _c[0], nativeEvt = _c[1];
                            return Object.assign({}, acc, (_b = {},
                                _b[reactEvt] = function () {
                                    var _a;
                                    var rest = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        rest[_i] = arguments[_i];
                                    }
                                    if (nativeEvt === 'close') {
                                        _this.hide();
                                    }
                                    // TODO 返回最后一个执行函数的值，实际应该只让监听一次
                                    return ((_a = _this.eventListeners[nativeEvt]
                                        .map(function (item) {
                                        return item.apply(void 0, __spreadArray([], __read(rest), false));
                                    })
                                        .slice(-1)[0]) !== null && _a !== void 0 ? _a : true);
                                },
                                _b));
                        }, {});
                        return [4 /*yield*/, this.then()];
                    case 1:
                        publicConfig = _b.sent();
                        return [4 /*yield*/, this.getAuthClient()];
                    case 2:
                        authClient = _b.sent();
                        if (this.options.config) {
                            this.options.config.host =
                                this.options.host || "https://".concat(publicConfig.requestHostname);
                        }
                        return [2 /*return*/, ReactDOM.render(React.createElement("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: this.options.align
                                } },
                                React.createElement(ReactAuthingGuard, __assign({}, evts, { appId: this.options.appId, tenantId: this.options.tenantId, config: this.options.config, visible: this.visible, authClient: authClient }))), Guard.getGuardContainer((_a = this.options.config) === null || _a === void 0 ? void 0 : _a.target), cb)];
                }
            });
        });
    };
    Guard.prototype.on = function (evt, handler) {
        ;
        this.eventListeners[evt].push(handler);
    };
    Guard.prototype.show = function () {
        this.visible = true;
        this.render();
    };
    Guard.prototype.hide = function () {
        this.visible = false;
        this.render();
    };
    Guard.prototype.unmount = function () {
        var _a;
        var node = Guard.getGuardContainer((_a = this.options.config) === null || _a === void 0 ? void 0 : _a.target);
        if (node) {
            ReactDOM.unmountComponentAtNode(node);
        }
    };
    return Guard;
}());
export { Guard };
